import DHTMLPopupWithMoire from './dhtml_popup_with_moire'
import messageResource from './messageResource'
import Spinner from './spin.min'
import $ from 'jquery'
import _ from 'underscore'

export default function LoadingPopup(){}

LoadingPopup.prototype = _.create(DHTMLPopupWithMoire.prototype);

LoadingPopup.prototype.init = function ( divId, captionText )
{
    DHTMLPopupWithMoire.call( this, divId );

    this.hideOnMouseDown = function () { return false; };
    this.hideOnResize = function () { return false; };
    this.hideOnEscape = function () { return false; };

    this._contentContainer = $( '#' + divId + ' .content' );
    this._spinnerPlaceholder = $( '#' + divId + ' .spinner' );
    this._captionTextPlaceholder = $( '#' + divId + ' .captionText' );
    this._captionTextPlaceholder.text( captionText ? captionText : messageResource.getMessage( "common.popup.loading" ) );

    const spinnerOptions = {
        lines: 11, // The number of lines to draw
        length: 4, // The length of each line
        width: 3, // The line thickness
        radius: 6, // The radius of the inner circle
        corners: 1, // Corner roundness (0..1)
        rotate: 0, // The rotation offset
        direction: 1, // 1: clockwise, -1: counterclockwise
        color: '#fff', // #rgb or #rrggbb
        speed: 1, // Rounds per second
        trail: 60, // Afterglow percentage
        shadow: false, // Whether to render a shadow
        hwaccel: false, // Whether to use hardware acceleration
        className: 'spinner', // The CSS class to assign to the spinner
        zIndex: 2e9, // The z-index (defaults to 2000000000)
        top: 'auto', // Top position relative to parent in px
        left: 'auto' // Left position relative to parent in px
    };
    this._spinner = new Spinner( spinnerOptions );

    return this;
};

LoadingPopup.prototype.show = function ()
{
    this._isHided = false;
    this._contentContainer.addClass( "disabled" );
    DHTMLPopupWithMoire.prototype.show.call( this );

    const self = this;
    setTimeout( function ()
                {
                    if( !self._isHided )
                    {
                        self._contentContainer.removeClass( "disabled" );
                        self._spinner.spin( self._spinnerPlaceholder[0] );
                    }
                }, 200 );
};

LoadingPopup.prototype.hide = function ()
{
    this._isHided = true;
    this._spinner.stop();
    DHTMLPopupWithMoire.prototype.hide.call( this );
};

LoadingPopup.prototype.setOnEscapeCallback = function ( onEscapeCallback )
{
    this.hideOnEscape = function () { return true; };
    this._onEscapeCallback = onEscapeCallback;
};

LoadingPopup.prototype.onEscape = function ()
{
    DHTMLPopupWithMoire.prototype.onEscape.call( this );
    if ( this._onEscapeCallback )
        this._onEscapeCallback();
};



// WEBPACK FOOTER //
// ./web/js/LoadingPopup.js